// 法语 French
import frLocale from "element-ui/lib/locale/lang/fr";
const fr = {
  login: {
    buttoo: {
      add: "add",
    },
  },
  dialog: {
    buttton: {
      close: "Fermer",
    },
    ReportError: {
      next: "suivant",
      h1: "Le rapport d'erreurs permet aux utilisateurs de communiquer avec nous pour résoudre tout problème de données et améliorer la qualité des données.",
      li1: "Si vous rencontrez des problèmes de données ou si vous avez une question sur ces données",
      li2: "Si vous souhaitez apporter des informations sur l'entreprise pour améliorer ces données",
      li3: "Si vous choisissez de ne pas divulguer les informations de votre propre entreprise que vous pourriez considérer comme privées",
      li4: "Si vous avez des suggestions constructives à nous faire pour améliorer les services",
      h2: "Tous les commentaires soumis sont soumis à une vérification des données. Les utilisateurs doivent compléter votre propre profil d'utilisateur car notre représentant peut vous contacter pour l'authentification et la vérification des droits de votre entreprise pour représenter votre entreprise.",
      Iamanemployeeofthissubjectcompany: "Je suis employé de cette entreprise",
      Reportmycompany: "Signaler mon entreprise",
      Updatedata: "Mise à jour des données",
      Reportinformationerrors: "Signalez les erreurs d'information",
      Reportotherscompany: "Signaler d'autres entreprises",
      Financial: "Financière",
      Pleaseprovidemoreinfo: "Veuillez fournir plus d'informations",
      Year: "Année",
      Business: "Entreprise",
      Noofemployees: "Nombre d'employés",
      Coremanagement: "Gestion de base",
      Corebusinessactivites: "Activités principales",
      IntBusiness: "Commerce international",
      Pleasedescribeyouractivites: "Veuillez décrire vos activités",
      Pleaselistcountriesyoudobusine:
        "Veuillez indiquer les pays dans lesquels vous faites des affaires",
      Corecompetency: "Compétence de base",
      Businessoutlook: "Perspectives commerciales",
      Uploadfiles: "Téléverser des fichiers",
      Upload: "Télécharger",
      Cancel: "Annuler",
      Submit: "Soumettre",
      Select: "Sélectionner",
      Selectthedatacategoryyoureport:
        "Sélectionnez la catégorie de données que vous signalez",
      TotalCurrentAssets: "Actifs courants totaux",
      CashBank: "Espèces et banque",
      Accountreceivable: "Comptes clients",
      AdvancestoSuppliers: "Avances aux fournisseurs",
      Inventory: "Inventaire",
      Tobeappointedexpense: "Dépenses à prévoir",
      Totalnoncurrentassets: "Total des actifs non courants",
      Longterminvestment: "Investissement à long terme",
      Fixedassetsnetvalue: "valeur nette des immobilisations",
      Projectsunderconstruction: "Projets en construction",
      Longtermtobeappointedexpenise: "Dépenses à long terme à nommer",
      Deferredtaxdebit: "Débit d'impôt différé",
      Totalcurrentliabilities: "Passif courant total",
      Accountpayable: "Comptes fournisseurs",
      Advancesfromclients: "Advances from clients",
      Salariespayable: "Salaires à payer",
      Taxespayable: "Impôts à payer",
      Otheraccountspayable: "Autres comptes fournisseurs",
      Totalequity: "Capitaux propres totaux",
      Paidupcapital: "Capital libéré",
      Capitalreserves: "réserves de capital",
      Surplusreserves: "Réserves excédentaires",
      Undistrbutedporfit: "Bénéfices non distribués",
      Totalassets: "Total de l'actif",
      Turnover: "Chiffre d'affaires",
      Costofgoodssold: "Coût des marchandises vendues",
      Salestax: "taxe de vente",
      Grossprofit: "Bénéfice brut",
      Otheroperatingprofils: "Autres profils opérationnels",
      Salesexpense: "Frais de vente",
      Managementexpense: "Frais de gestion",
      Financeexpense: "Frais financiers",
      Operatingprofit: "résultat d'exploitation",
      Nonoperatingincome: "Revenus hors exploitation",
      Profitbeforetax: "Bénéfice avant impôt",
      Incometax: "impôt sur le revenu",
      Netincome: "Revenu net",
      DataProblems: "Problèmes de données",
      CorrectInformation: "Informations correctes",
    },
  },
  Home: {
    Applications: "Applications",
    SearchCompanies: "Rechercher des entreprises",
    SearchLeads: "Rechercher des prospects",
    SearchTrade: "Rechercher un commerce",
    SearchSanctions: "Rechercher des sanctions",
    SearchNews: "Rechercher des actualités",
    RiskScan: "Analyse des risques",
    SearchRelationship: "Relation de recherche",
    DataServices: "Services de données",
    SearchCountries: "Rechercher des pays",
    selectCountry: "Sélectionner un pays",
    Entercompanyname: "Entrez le nom de l'entreprise",
    keWord: "Mot-clé", //关键词
    firstWord: "Exactement à gauche", //首词
    search: "Recherche", //搜索
    homeSeachTitle: "Pleins feux sur les entreprises", //聚焦全球商情
    homeTitleDetail:
      "CSI, cabinet de recherche et d'informatique axé sur les données, est spécialisé dans le crédit, le risque et le big data. Il propose des outils numériques aux investisseurs et aux professionnels du monde entier, exploitant des analyses et des algorithmes avancés pour fournir des informations visuelles rapides et faciliter la prise de décision.",
    phoneTitleDetail:
      "Pour rechercher, consulter et obtenir rapidement des informations sur les entreprises, vous pouvez également utiliser l'application CSI sur votre téléphone.", //您可以使用手机上的 CSI App 快速搜索、查看和获取公司信息。,
    searchCompanyNum:
      "Recherchez plus de 500 millions d'entreprises dans plus de 200 pays et territoires",
    newsHeadTitle:
      "Découvrez les informations stratégiques qui se cachent derrière chaque titre d'entreprise",
    sanctionHeadTitle:
      "Naviguez en toute confiance dans le commerce international en vérifiant que les entreprises et les produits ne sont pas soumis aux sanctions internationales",
    tradeHeadTitle:
      "Transformer les données du commerce mondial en informations stratégiques sur le marché",
    relationshipTitle:
      "Propriété et contrôle ultimes / Empreinte d'investissement / Réseau de chaîne d'approvisionnement / Simplification de la conformité / Atténuation des risques / Couverture mondiale",
    IndustryAnalysis: "Analyse de l'industrie",
    BusinessAnalytics: "Analyse commerciale",
    ImportExportData: "Données d'import-export",
    CompanyNews: "Actualités de l'entreprise",
    Sanctions: "Sanctions",
    BusinessIntelligence: "Intelligence d'affaires",
    CompanyIdentityVerification: "Vérification de l'identité de l'entreprise",
    KYCSolutions: "Solutions KYC",
    OwnershipPenetration: "Pénétration de la propriété",
    CompanyFinancialAnalysis: "Analyse financière de l'entreprise",
    CreditRatings: "Cotes de crédit",
    CreditReports: "Rapports de crédit",
    ESGRatings: "Notations ESG",
    VendorScreening: "Sélection des fournisseurs",
    MarketResearch: "Étude de marché",
    EnterKeyword: "Saisissez le mot-clé",
    Country: "Pays",
    Company: "Entreprise",
    Person: "Personne",
    Product: "Produit",
    EnterPersonName: "Entrez le nom de la personne",
    EnterCountryName: "Entrez le nom du pays",
    EnterproductName: "Saisissez les mots-clés du produit",
    EnterproductNamekeywordsorHSCode:
      "Entrez les mots clés du produit ou le code HS",
    Searchby: "Recherche par",
    SICStandardIndustryCode: "SIC - Code type d'industrie",
    HSCodeHarmonizedSystemCode: "Code SH - Code du Système Harmonisé",
    AIAssistance: "Assistance IA",
    EnterISICNACENAICSCSICAAAICGICS:
      "Entrez ISIC / NACE / NAICS / CSIC / AAAIC / GICS",
    EnterHarmonizedSystemCode: "Saisissez le code du système harmonisé",
    SIC: "SIC",
    HSCode: "HSCode",
  },
  Toolbar: {
    Filter: "Filtre",
    Select: "Sélectionner",
    Edit: "Modifier",
    Sortby: "Trier par",
    Collect: "Collecter",
    Saved: "Enregistré",
    Compare: "Comparer",
    Export: "Exporter",
    Download: "Télécharger",
    Update: "Mettre à jour",
    Reporterror: "Signaler une erreur",
    Share: "Partager",
    ascending: "ascendant",
    descending: "décroissant",
    Yourfolder: "Votre dossier",
    RiskScanning: "Analyse des risques",
    CreditAssessment: "Évaluation de crédit",
    DataAnalysis: "Analyse des données",
    NewPortfolio: "Nouveau portefeuille",
    Print: "Imprimer",
    Optimize: "Optimiser",
    ALL: "Tous",
    Confirm: "Confirmer",
  },
  Export: {
    Choosethedatafields:
      "Choisissez les champs de données que vous souhaitez exporter.",
    Enterkeywords: "Saisissez le mot-clé",
    Financialdata: "données financières",
    Reset: "Réinitialiser",
    Back: "Dos",
    Howmanyresults:
      "Combien de résultats souhaitez-vous exporter pour cette recherche? Vous pouvez également affiner votre recherche en ajoutant des filtres supplémentaires.",
    FileName: "Nom de fichier",
    Pleaseenterafilename: "Veuillez saisir un nom de fichier",
    SelectedList: "Liste sélectionnée",
  },
  AiZaba: {
    whatareyousearchingfor: "que cherches-tu?",
    CreditAnalyst: "Analyste de crédit",
    Assesses:
      "Évalue la solvabilité d’une entreprise, identifie les risques financiers et garantit des transactions sécurisées grâce à l’analyse des données et aux notations de crédit.",
    LegalAdvisor: "Conseiller juridique",
    Provides:
      "Fournit des conseils en matière de conformité, examine les contrats et évalue risques juridiques pour garantir que les opérations commerciales sont conformes aux lois et éviter les litiges.",
    BizConsultant: "Consultant en affaires",
    Optimizes:
      "Optimise les chaînes d'approvisionnement, identifie les acheteurs et stimule les ventes en analysant les tendances du marché et en proposant des stratégies sur mesure pour améliorer l'efficacité.",
    EconomicAnalyst: "Analyste économique",
    Analyzes:
      "Analyse les tendances économiques de l'industrie et de la région, aidant les entreprises prennent des décisions éclairées et restent compétitives.",
    HiImZabaYourresearchassistant:
      "Bonjour, je suis Zaba – votre assistante de recherche",
  },
  navigationBar: {
    Notifications: "Notifications", //通知
    MarkasRead: "Marquer comme lu", //标记已读
    Viewall: "Tout afficher", //查看全部
    SilverSubscriber: "Abonné Silver", //银级用户
    GoldSubscriber: "Abonné Gold", //金级用户
    SubscriptionExpires: "L'abonnement expire",
    AvailableCredits: "Crédits disponibles", //可用积分
    AddCredits: "Ajouter des crédits", //购买积分
    IndivdualAccount: "Compte individuel", //个人账号
    GroupAccount: "Compte de groupe", //集团账号
    UserAccount: "Compte utilisateur",
    Roles: "Postes", //角色
  },
  ListofResults: {
    Country: "Pays",
    Industry: "Secteur",
    CompanyType: "Type d'entreprise",
    CompanySize: "Taille de l'entreprise",
    CompanyStatus: "Statut de l'entreprise",
    CompanyName: "Nom de l'entreprise",
    RegStatus: "Statut d'immatriculation",
    StateProvince: "État/Province",
    CityCounty: "Ville/Comté",
    DistrictCity: "District/Ville",
    IncDate: "Date de constitution",
    LegalForm: "Forme juridique",
    CoID: "Numéro d'identification de l'entreprise",
    TaxNo: "N° fiscal",
    ListingInfo: "Informations d'inscription",
    Phone: "Téléphone",
    Website: "Site web",
    Email: "E-mail",
    LegalPerson: "Personne morale",
    PostCode: "Code postal",
    ISIC: "ISIC",
    IndustryDescription: "Description du secteur",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "Notation de crédit",
    SolvencyIndex: "Indice de solvabilité",
    ProbabilityofDefault: "Probabilité de défaut",
    NoofEmployees: "Nombre d'employés",
    Revenue: "Chiffre d'affaires",
    TotalAsset: "Actif total",
    NetProfit: "Bénéfice net",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "Afficher plus",
    SelectCountry: "Sélectionnez un pays",
    ClearAll: "Tout effacer",
    SelectIndustry: "Sélectionnez l'industrie",
    ListedCompany: "Société cotée",
    YearsinBusiness: "Années en affaires",
    Sharethisinformation: "Partagez cette information",
    Pleaseaddress: "Veuillez saisir une ou plusieurs adresses e-mail",
    Example: "Exemple",
    message: "message",
    pleaseleaveamessage: "s'il vous plaît laissez un message",
    Include: "Inclure",
    thisaddress: "le nom de cette entreprise, son identifiant, son adresse",
    CSIwebsite: "Site Internet du CSI",
    Update: "Mise à jour",
    Iftheavailable:
      "Si les données en ligne disponibles sont insuffisantes ou obsolètes, vous pouvez cliquer sur le bouton « Mettre à jour » pour demander une mise à jour instantanée d'un nouveau rapport de crédit d'entreprise faisant l'objet d'une enquête auprès de nos enquêteurs de réseau local ou de nos agences d'évaluation du crédit. Le coût de cette mise à jour est de 1 crédit par entreprise. La livraison du rapport de mise à jour prend généralement entre 24 et 72 heures.",
    Abusinesscredit:
      "Un rapport de crédit commercial fournit des informations détaillées sur les données d'identification de l'entreprise concernée, les registres du registre, la structure de l'actionnariat, l'historique de l'entreprise, la description de la direction, les sociétés liées, les opérations réelles, les références commerciales, les données et analyses financières, les informations publiques officielles telles que les dossiers de litiges et les sanctions, ainsi que l'analyse et l'évaluation du crédit.",
    Searchcompanies: "Rechercher plus d'e-mails sur d'autres sociétés",
    Rowsperpage: "Lignes par page",
    Remove: "Supprimer",
    Confirm: "Confirmer",
  },
  ContentTabs: {
    Background: "Contexte",
    BusinessActivities: "Activités commerciales",
    Performance: "Performance",
    Publications: "Publications",
    CreditOpinion: "Avis de crédit",
    MarketAnalysis: "Analyse de marché",
    Snapshot: "Aperçu",
    Profile: "Profil",
    Ownership: "Actionnariat",
    RelatedCompanies: "Sociétés liées",
    Management: "Direction",
    Operations: "Opérations",
    Locations: "Implantations",
    Industry: "Secteur",
    ImportExport: "Importation et exportation",
    SupplyChain: "Chaîne d'approvisionnement",
    FinancialHighlights: "Points financiers marquants",
    RatioAnalysis: "Analyse des ratios",
    IndustryNorm: "Norme du secteur",
    News: "Actualités",
    Sanctions: "Sanctions",
    IndustryStatistics: "Statistiques du secteur",
    RatingAnalysis: "Analyse des notations",
    CompetitiveAnalysis: "Analyse concurrentielle",
  },
  Snapshot: {
    CompanyDQIdesc1:
      "L'indice de qualité des données (DQI) utilise des algorithmes pour évaluer différents aspects des données, notamment l'exhaustivité, la validité, la fiabilité des sources, la cohérence, l'actualité et le support bilingue.",
    CompanyDQIdesc2:
      "L'indice est conçu pour évaluer la qualité des données sur une échelle de 1 à 100, les scores plus élevés indiquant une qualité de données supérieure. Les algorithmes peuvent analyser les données sur la base de règles ou de critères prédéfinis, permettant ainsi des mesures objectives et standardisées.",
    CompanyDQIdesc3:
      "Notre indice de qualité des données (DQI) sert d'indicateur fiable, permettant aux utilisateurs d'évaluer quantitativement la qualité des données. Cela permet une prise de décision basée sur les données et améliore la valeur et l'utilité globales des données.",
    CountryDQIdesc1:
      "L'indice de qualité des données (DQI) évalue la fiabilité, l'exactitude et l'accessibilité des données entre les pays, reflétant les différences en matière d'infrastructure numérique, de gouvernance et de transparence. Les pays développés se classent généralement plus haut en raison de systèmes de données solides, de politiques ouvertes et de technologies avancées, tandis que les économies en développement sont souvent aux prises avec des lacunes en matière d'infrastructures, de réglementation ou de pratiques de partage de données.",
    CountryDQIdesc2:
      "Les facteurs clés incluent la transparence du gouvernement, les lois sur la protection des données et l’adoption technologique. Un DQI élevé permet de meilleures décisions politiques et commerciales, tandis qu'un score faible met en évidence les domaines nécessitant des investissements.",
    CompanyDQI: "DQI de l'entreprise", //公司数据质量指数 DQI
    CountryDQI: "Pays DQI", //国家数据质量指数 DQI
    CompanyTitle: "Indice de qualité des données (DQI) par entreprise",
    CountryTitle: "Indice de qualité des données (DQI) par pays",
    Address: "Adresse", //地址
    CountyCity: "Comté/Ville", //县/市
    ProvinceState: "Province/État", //省/州
    CountryRegion: "Pays/Région", //国家/地区
    ZipCode: "Code postal", //邮政编码
    Website: "Site web", //网站
    Email: "E-mail", //电邮
    Tel: "Tél", //电话
    LastUpdate: "Dernière mise à jour", //最近更新
    DataSource: "Source des données", //数据来源
    LegalStatus: "Statut juridique", //法定状况
    CoID: "ID de l'entreprise", //公司ID
    CompanyType: "Type d'entreprise", //公司类型
    RegistrationDate: "Date d'enregistrement", //注册日期
    RegistrationStatus: "Statut d'enregistrement", //注册状态
    Listed: "Cotée", //上市信息
    CurrentOpperations: "Opérations actuelles", //经营状况
    IndustryCode: "Secteur d'activité", //行业代码
    BusinessActivities: "Activités commerciales", //主营业务
    NoofEmployees: "Nombre d'employés", //员工数量
    NoofShareholders: "Nombre d'actionnaires", //股东数量
    Management: "Direction", //管理状况
    Performance: "Performance", //业绩表现
    Revenue: "Chiffre d'affaires", //收入
    Assets: "Actifs", //资产
    ProfitLoss: "Bénéfice/Perte", //利润
    Growth: "Croissance", //公司增长
    Competitiveness: "Compétitivité", //竞争力
    CreditOpinion: "Avis de crédit", //信用状况
    CreditRating: "Notation de crédit", //信用评级
    CreditScore: "Score de crédit", //信用评分
    ESGRating: "Notation ESG", //ESG 评级
    Solvency: "Solvabilité", //偿还能力
    Sanctions: "Sanctions", //全球制裁
    CoName: "Nom de l'entreprise",
    RegName: "Nom enregistré",
  },
  Profile: {
    CompareCompanies: "Comparez les entreprises",
    AddaCompany: "Ajouter une entreprise",
    SubjectCompany: "Entreprise concernée", //目标公司
    ComparisonCompany: "Société de comparaison",
    CompanyProfile: "Profil de l'entreprise", //基本资料
    CompanyName: "Nom de l'entreprise", //公司名称
    NativeName: "Nom d'origine", //当地名称
    CompanyID: "Numéro d'identification de l'entreprise", //公司 ID
    VATNumber: "Numéro de TVA", //VAT号
    StockCode: "Code boursier", //股票代码
    Listed: "Cotation", //上市日期
    RegistrationDate: "Date d'immatriculation", //注册日期
    LegalForm: "Forme juridique", //公司性质
    CompanyType: "Type d'entreprise", //公司类型
    LegalStatus: "Statut juridique", //注册状态
    Jurisdiction: "Juridiction", //司法管辖区
    RegisteredAddress: "Adresse enregistrée", //注册地址
    ProvinceState: "Province/État", //省/州
    CountryRegion: "Pays/Région", //国家/地区
    ZipCode: "Code postal", //邮政编码
    OperatingAddress: "Adresse d'exploitation", //经营地址
    LastUpdate: "Dernière mise à jour", //最近更新
    DataSource: "Source des données", //数据来源
    History: "Historique", //历史记录
    RegisteredCapital: "Capital social",
    PaidinCapital: "Capital versé",
    CountyCity: "Comté/Ville",
    OtherName: "Autre nom",
  },
  Ownership: {
    TotalPartiesInvolved: "Nombre total de parties impliquées",
    UltimateBeneficiaryOwner: "Bénéficiaire effectif ultime (UBO)", //最终受益人
    NaturalPersonShareholder: "Actionnaire personne physique", //涉及自然人股东
    CorporateShareholders: "Actionnaires institutionnels", //涉及法人股东
    ShareholderLevel: "Niveau d'actionnaire", //股东层级x
    Name: "Nom", //名称
    Country: "Pays", //国家/地区
    Location: "Localisation", //地点
    Type: "Type", //类型
    Shares: "Actions", //股份
    Relation: "Lien", //关系
    RelatedCompany: "Entreprises apparentées",
    CompanyShareholders: "Actionnaires de la société",
    NGOShareholders: "Actionnaires d'ONG",
    SubjectInvestments: "Investissements du sujet",
  },
  RelatedCompanies: {
    Total: "Entités totales", //相关公司总计
    Countries: "Pays", //国家/地区
    Branches: "Succursales", //分支机构
    RelatedComp: "Sociétés liées", //关联公司
    Name: "Nom", //名称
    Country: "Pays", //国家/地区
    Location: "Localisation", //地点
    Type: "Type", //类型
    Relationship: "Relation", //关系
    BranchOffices: "Succursales",
    Subsidiaries: "Filiales",
  },
  Management: {
    Management: "Management", //管理层
    ContactInfo: "Coordonnées", //联系人信息
    Countries: "Pays", //国家/地区
    Name: "Nom", //名称
    Position: "Poste", //职位
    Department: "Service", //部门
    Country: "Pays", //国家/地区
    ShareholderNot: "Actionnaire ou non", //是否股东
    Relation: "Relations", //关系
    Verification: "Vérification", //已验证
    Searchmoreemails: "Rechercher d'autres adresses e-mail", //搜索更多电邮
    Roles: "Postes", //角色
    EducationLevel: "Niveau d'études", //教育程度
    Phone: "Téléphone", //电话
    Email: "E-mail", //电邮
    Verified: "Vérifié", //已验证
    Searchmore: "Rechercher d'autres adresses e-mail sur d'autres entreprises", //搜索更多其他公司的电邮
    Pleaseentername: "Veuillez entrer le nom",
    PleaseenterWebsite: "Veuillez saisir le nom de l'entreprise ou le domaine",
    UserSelfVerification: "Auto-vérification de l'utilisateur",
    Userverified: "Utilisateur vérifié",
    Source: "Source",
  },
  Operations: {
    LineofBusiness: "Secteur d'activité", //业务范围
    BusinessTerritories: "Territoires d'activité", //业务区域
    ImportExport: "Importation et exportation", //进出口信息
    Viewtradeinfo: "Voir plus d'informations commerciales", //查看更多贸易信息
    ProductsServices: "Produits/Services", //产品/服务
    Products: "Produits", //产品
    ProductImage: "Image du produit", //产品图片
    ProductName: "Nom du produit", //产品名称
    ProductDescription: "Description du produit", //产品描述
    Details: "Détails", //详情
    Addproductinformation: "Ajouter des informations sur le produit", //添加产品信息
    Showcaseyourcompany:
      "Si vous souhaitez présenter les produits ou services de votre entreprise au public, vous pouvez ajouter les informations sur vos produits et services ici. C'est un excellent moyen de promouvoir votre entreprise. Une fois que nous aurons examiné votre soumission, vos données seront publiées.",
  },
  Locations: {
    CoName: "Nom de l'entreprise", //业务范围
    Relationship: "Relation", //关系
    Type: "Type", //类型
    Country: "Pays", //国家/地区
    Location: "Localisation", //地点
    Address: "Adresse", //地址
    Edit: "Modifier", //编辑
    CompanyLocatiionsMap: "Emplacements de l'entreprise sur la carte", //地图中的公司位置
    Selectaddresstype: "Sélectionner le type d'adresse", //选择地址类型
    Subjectcompany: "Société concernée", //目标公司
    Subsidiary: "Filiale", //子公司
    RegisteredAddress: "Adresse du siège social", //注册地址
    OperationAddress: "Adresse de l'établissement", //运营地址
    All: "Tous", //全部
    Showlocation: "Afficher les emplacements",
  },
  Industry: {
    IndustryTitle: "Intitulé du secteur", //IndustryTitle
    IndustryDescription: "Description du secteur", //IndustryDescription
    ISIC: "CITI", //ISIC
    ISICDescription: "Description CITI", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "Description NACE", //NACEDescription
    NAICS: "SCIAN", //NAICS
    NAICSDescription: "Description SCIAN", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "Description CSIC", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "Description AAACIC", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "Description GICS", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Montant total des importations", //进口总额
    TopImportCountry: "Principaux pays d'importation", //最大进口国家/地区
    TopImportProduct: "Principaux produits d'importation", //最大进口产品
    TotalExport: "Monto total de las exportaciones", //出口总额
    TopExportCountry: "Principaux pays d'exportation", //最大出口国家/地区
    TopExportProduct: "Principaux produits d'exportation", //最大出口产品
    TradeVolume: "Volume des échanges", //贸易额
    ImportShipments: "Expéditions d'importation", //进口量
    ExportShipments: "Expéditions d'exportation", //出口量
    ImportCountries: "Pays d'importation", //进口国家/地区
    ExportCountries: "Pays d'exportation", //出口国家/地区
    ImportVolume: "Volume des importations", //进口量
    ExportVolume: "Volume des exportations", //出口量
    Suppliers: "Principaux fournisseurs", //主要供应商
    Shipments: "Par nombre d'expéditions", //按出货量
    Buyers: "Principaux acheteurs", //主要买家
    ImportQuantity: "Quantité importée", //进口数量
    IncreaseDecreasexRate: "Taux d'augmentation/diminution", //增/减率
    ExportQuantity: "Quantité exportée", //出口数量
    ImportsExportsRecords: "Enregistrements d'importations et d'exportations", //进出口记录
    Date: "Date", //日期
    Product: "Produit", //产品
    HSCode: "Code SH", //HS 编码
    BuyerName: "Nom de l'acheteur", //买家名称
    Destination: "Destination", //目的地
    SupplierName: "Nom du fournisseur", //供应商名称
    Origin: "Origine", //原产地
    Amount: "Montant (USD)", //金额
    Details: "Détails", //详情
    Imports: "Importations",
    Exports: "Exportations",
    Shipments2: "Expéditions",
    value2: "valeur",
    value: "Par nombre de valeur",
    viewmoretradeinfo: "voir plus d'informations commerciales",
    SearchHSCode: "Rechercher le code HS",
    Selectdate: "Sélectionnez une date",
  },
  SupplyChain: {
    Illustratesthesubjectcompany:
      "Ce graphique illustre les relations « acheter auprès de » et « vendre à » de l’entreprise concernée. Plus le volume est grand, plus le tube est épais.",
  },
  ShippingOrderDetails: {
    Date: "Date",
    MasterBillofLading: "Connaissement principal",
    Source: "Source",
    BillNo: "N° de facture",
    ImporterBuyer: "Importateur / Acheteur",
    ExporterSeller: "Exportateur / Vendeur",
    Name: "Nom",
    Address: "Adresse",
    Country: "Pays",
    Contact: "Contact",
    Email: "E-mail",
    CargoInfo: "Informations sur le fret",
    HSCode: "Code SH",
    Quantity: "Quantité",
    WeightUnit: "Unité de poids",
    ProductDescription: "Description du produit",
    Amount: "Montant (USD)",
    QuantityUnit: "Unité de quantité",
    Weight: "Poids",
    HSDescription: "Description SH",
    Incoterms: "Incoterms",
    ShippingInfo: "Informations d'expédition",
    Vessel: "Navire",
    Consignee: "Destinataire",
    MeansofTransport: "Moyen de transport",
    CountryofOrigin: "Pays d'origine",
    Voyage: "Voyage",
    Notifier: "Notificateur",
    CountryofDestnation: "Pays de destination",
    AddressofOrigin: "Adresse d'origine",
    Shipper: "Expéditeur",
    AddressofDestnation: "Adresse de destination",
    Container: "Conteneur",
    ContainerID: "ID du conteneur",
    ContainerType: "Type de conteneur",
    ContainerDescDode: "Description du conteneur",
    ContainerSize: "Taille du conteneur",
    ImportExport: "Importateur / Exportateur",
    Imports: "Importations",
    Exports: "Exportations",
  },
  FinancialHighlight: {
    Revenue: "Chiffre d'affaires", //收入
    Profit: "Bénéfice", //利润
    Growth: "Croissance", //增长
    CashFlowStatus: "Trésorerie", //现金流状况
    FinancialStructure: "Structure financière", //融资结构
    CreditOpinion: "Avis de crédit", //信用评估
    RiskIndicator: "Indicateur de risque", //风险指标
    Solvencyindex: "Indice de solvabilité", //偿还指数
    Year: "Année", //年份
    Change: "Variation", //变化
    NetProfit: "Bénéfice net",
    TotalAssets: "Total de l'actif",
    Equity: "Capitaux propres",
    GrossMargin: "Marge brute",
    ProfitMargin: "Marge bénéficiaire",
    ReturnonEquity: "Rendement des capitaux propres",
    CurrentRatio: "Ratio de liquidité",
    DebtRatio: "Taux d'endettement",
    FinancialHighlights: "Données financières des sociétés liées", //关联公司财务数据
    FinancialHighlightsTitle: "Points clés financiers des sociétés liées", //关联公司财务摘要
    CompanyName: "Nom de l'entreprise", //公司名称
    CompanyID: "Numéro d'identification de l'entreprise", //公司ID
    Country: "Pays", //国家/地区
    CompanyStatus: "Statut de l'entreprise", //公司状态
    Cancel: "Annuler", //取消
    Select: "Sélectionner",
    Relations: "Relations", //关系
    Financialperformancedata:
      "Les données sur la performance financière sont collectées auprès de diverses sources gouvernementales et d'agences locales d'évaluation du crédit. De plus, des études de marché et industrielles sont utilisées pour calculer et modéliser les données. Pour des informations plus détaillées sur les opérations réelles et l'analyse des performances, veuillez contacter notre équipe de service pour demander un rapport de diligence raisonnable de l'entreprise.",
    Whenthesubjectsdata:
      "Lorsque les données du sujet sont insuffisantes ou que vous souhaitez obtenir plus d'informations sur votre client, cette plate-forme offre une vue complète de toutes les entités liées au sujet. Cela inclut les actionnaires de la société en question, les sociétés liées, etc.",
    Byprovidingyou:
      "En vous offrant une perspective plus large, cette plateforme vous permet de faire des évaluations plus éclairées et d'acquérir une compréhension plus approfondie de votre sujet.",
    PleaseSelectTheYeartoDisplay: "Veuillez sélectionner l'année à afficher",
    SelectUptoThreeYears: "Sélectionnez jusqu'à trois ans",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "Ratios de rentabilité",
    Year: "Année",
    Change: "Variation",
    Returnonequity: "Rendement des capitaux propres",
    Returnonassets: "Rendement des actifs",
    Profitmargin: "Marge bénéficiaire",
    Grossmargin: "Marge brute",
    OperatingRatios: "Ratios d'exploitation",
    Assetsturnover: "Rotation des actifs",
    Stockturnover: "Rotation des stocks",
    Salesperiod: "Période de vente",
    Collectionperiod: "Période d'encaissement",
    Creditperiod: "Période de crédit",
    StructuralRatios: "Ratios de structure",
    Currentratio: "Ratio de liquidité",
    Quickratio: "ratio de liquidité générale",
    Shareholdersliquidityratio: "Ratio de liquidité des actionnaires",
    Solvencyratio: "Ratio de solvabilité",
    Debtratio: "Ratio d'endettement",
    ProductivityRatios: "Ratios de productivité",
    Profitperemployee: "Bénéfice par employé",
    Operatingrevenueperemployee: "Revenu d'exploitation par employé",
    Shareholdersfundsperemployee: "Fonds propres par employé",
    Totalassetsperemployee: "Total des actifs par employé",
    GrowthRatios: "Ratios de croissance",
    Salesgrowthrate: "Taux de croissance des ventes",
    Netprofitgrowthrate: "Taux de croissance du bénéfice net",
    Totalassetsgrowthrate: "Taux de croissance du total des actifs",
    FinancialHighlights: "Données financières des sociétés liées", //关联公司财务数据
    RatioAnalysis: "Analyse des ratios des sociétés liées", //关联公司比率分析
    CompanyName: "Nom de l'entreprise",
    CompanyID: "Numéro d'identification de l'entreprise",
    Country: "Pays",
    CompanyStatus: "Statut de l'entreprise",
    Relations: "Relations",
  },
  IndustryNorms: {
    IndustryStatistics: "Statistiques sectorielles",
    ofcompaniesintheIndustry: "Nombre d'entreprises du secteur",
    oflistedCompaniesintheIndustry: "Nombre d'entreprises cotées",
    oflargecompaniesintheIndustry: "Nombre de grandes entreprises du secteur",
    ofSMEsintheIndustry: "Nombre de PME du secteur",
    ofcompaniesinsample: "Nombre d'entreprises de l'échantillon",
    ofcompaniesinloss: "Nombre d'entreprises déficitaires",
    Observations: "Observations",
    AverageValue: "Valeur moyenne",
    MedianValue: "Valeur médiane",
    MaximumValue10: "Valeur maximale : 10 %",
    MinimumValue10: "Valeur minimale : 10 %",
    SubjectCompany: "Entreprise concernée",
    YearsinBusiness: "Nombre d'années d'activité",
    TotalAssets: "Actif total",
    TotalEquity: "Capitaux propres",
    Revenue: "Chiffre d'affaires",
    NetEarning: "Bénéfice net",
    Returnonassets: "Rendement des actifs",
    Performance: "Performance",
    ProfitabilityRatios: "Ratios de rentabilité",
    Returnonequity: "Rendement des capitaux propres",
    Grossmargin: "Marge brute",
    OperatingRatios: "Ratios d'exploitation",
    Stockturnover: "Rotation des stocks",
    Accountsreceivableturnover: "Rotation des créances clients",
    Assetsturnover: "Rotation des actifs",
    Totalassetturnover: "Rotation totale des actifs",
    StructuralRatios: "Ratios de structure",
    Currentratio: "Ratio de liquidité",
    Quickratio: "ratio de liquidité générale",
    Shareholdersliquidityratio: "Ratio de liquidité des actionnaires",
    GrowthRatios: "Ratios de croissance",
    Salesgrowthrate: "Taux de croissance des ventes",
    Netprofitgrowthrate: "Taux de croissance du bénéfice net",
    Totalassetsgrowthrate: "Taux de croissance de l'actif total",
  },
  Lawsutis: {
    Litigations: "Litiges",
    Date: "Date",
    CaseType: "Type de cas",
    Title: "Titre de l'affaire",
    CaseNo: "Cas n°",
    CauseofAction: "Cause d'action",
  },
  News: {
    Date: "Date", //日期
    Title: "Titre", //标题
    Source: "Source", //来源
    Impact: "Impact", //影响
    Searchcompanies: "Rechercher plus d'actualités sur d'autres entreprises", //国家/地区
    SearchforTitle: "Recherche de titre",
    CompanyName: "Nom de l'entreprise",
    Industry: "Industrie",
    Subjects: "Sujets",
    NewsTypes: "Types d'actualités",
    ByDate: "Par date",
    SelectCompanyName: "Sélectionnez le nom de l'entreprise",
    SelectIndustry: "Sélectionnez l'industrie",
    SelectSubjects: "Sélectionner les matières",
    SelectNewsType: "Sélectionner le type d'actualités",
    Negative: "Négative",
    Positive: "Positive",
  },
  Sanctions: {
    Potentialcompliance: "Risques potentiels de non-conformité détectés", //检测到潜在合规风险
    SeachbuttonNo:
      "Aucun élément préjudiciable n'a été détecté concernant cette entreprise.", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:
      "Pour rechercher d'autres dossiers de sanctions, cliquez sur le bouton « Rechercher des sanctions ».", //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Rechercher des sanctions", //搜索制裁
    ViewDetails: "Voir les détails", //查看详情
    Sanctions: "Sanctions", //制裁
    Potentialcompliancerisks: "Risques potentiels de non-conformité", //潜在合规风险
    IDInfo: "Informations sur l'ID", //ID 信息
    IDType: "Type d'ID", //ID 类型
    IDDescription: "Description de l'ID", //ID 描述
    SanctionList: "Liste des sanctions", //制裁名单
    SanctionListInvolved: "Liste des sanctions concernées", //涉及的制裁名单
    StartDate: "Date de début", //生效日期
    EndDate: "Date de fin", //结束日期
    SourceList: "Liste des sources", //来源名单
    SourceName: "Nom de la source", //来源名称
    ProfileNotes: "Notes de profil", //主体资料
    Link: "Lien", //链接
    Name: "Nom", //名称
    AssociationList: "Liste des associations",
    AssociationID: "Identifiant de l'association",
    AssociationType: "Type d'association",
  },
  CreditOpinion: {
    CreditAssessment: "Évaluation de crédit",
    CreditAssessmentfromtheRelatedCompanies:
      "Évaluation de crédit des sociétés liées",
    Year: "Année",
    CreditRating: "Notation de crédit",
    LocalCreditScore: "Score de crédit local",
    ProbabilityofDefault: "Probabilité de défaut",
    SolvencyIndex: "Indice de solvabilité",
    CreditLine: "Ligne de crédit",
    RiskIndicator: "Indicateur de risque",
    RelatedCreditAssessment: "Évaluation de crédit liée",
    CompanyName: "Nom de l'entreprise",
    CompanyID: "Identifiant de l'entreprise",
    Country: "Pays",
    CompanyStatus: "Statut de l'entreprise",
    Relations: "Relations",
    Cancel: "Annuler", //取消
    Select: "Sélectionner",
    CreditAssessmentMessage1:
      "Lorsque les données du sujet sont insuffisantes ou que vous souhaitez obtenir plus d'informations sur votre client, cette plate-forme offre une vue complète de toutes les entités liées au sujet. Cela inclut les actionnaires de la société en question, les sociétés liées, etc.",
    CreditAssessmentMessage2:
      "En vous offrant une perspective plus large, cette plateforme vous permet de faire des évaluations plus éclairées et d'acquérir une compréhension plus approfondie de votre sujet.",
    LocalCreditRating: "Cote de crédit locale",
    LocalCreditRatingDetail:
      "Poussé par la puissance du Big Data, 3ARating est un système de notation quantitative destiné aux entreprises privées. Il s'agit d'un effort de collaboration entre 3ACrédit et Creditreform Rating. Le modèle de notation est construit sur la base d'une évaluation complète de divers facteurs clés, notamment des facteurs non financiers, des facteurs financiers, des dossiers négatifs et des considérations spécifiques au secteur. Le modèle de notation présente un coefficient de Gini impressionnant, indiquant sa robustesse et sa fiabilité. 3ARating couvre une gamme de notations, de la note la plus élevée, 3A1, à la classe de notation la plus basse, 3A19.",
    CreditScore: "Pointage de crédit",
    CreditScoreDetail:
      "Les cotes de crédit sont calculées sur une échelle de 1 à 100, en fonction de la cote de crédit obtenue auprès des autorités locales. Un score plus élevé indique une meilleure solvabilité.",
    PossibilityofDefault: "Possibilité de défaut (PD)",
    PossibilityofDefaultDetail:
      "La possibilité de défaut (PD) est un outil utile pour l'évaluation des risques, axé sur l'évaluation de la liquidité à court terme.",
    SolvencyIndexSI: "Indice de Solvabilité (SI)",
    SolvencyIndexSIDetail:
      "L'indice de solvabilité (SI) est un indicateur d'alerte précoce très efficace et fiable qui permet une évaluation rapide de la solvabilité des partenaires commerciaux. Une valeur SI plus élevée indique un risque de défaut plus élevé de la part d'un client. Le SI va de 100, qui est considéré comme une excellente note, à 600, où des caractéristiques très négatives sont présentes.",
    ExternalRating: "Notation externe",
    DefaultProbability: "Probabilité par défaut (Pd1Year)",
    Rating: "3ARating (>=,<=)",
    PleaseSelectTheYeartoDisplay: "Veuillez sélectionner l'année à afficher",
    SelectUptoThreeYears: "Sélectionnez jusqu'à trois ans",
    HighRisk: "Risque élevé",
    Medium: "Moyen",
    Moderate: "Modérée",
    Average: "Moyenne",
    LowerThanAvg: "Inférieur à la moyenne",
    LowRisk: "Faible risque",
    CreditOpinion: "Avis de crédit",
  },
  IndustryStatistics: {
    SubjectCompany: "Entreprise concernée",
    Country: "Pays",
    Compare: "Comparer",
    Industry: "Secteur d'activité",
    CompanyType: "Type d'entreprise",
    CompanySize: "Taille de l'entreprise",
    CompanyStatus: "Statut de l'entreprise",
    YearsinBusiness: "Nombre d'années d'activité",
    CompanyRating: "Évaluation de l'entreprise",
    Liquidity: "Trésorerie",
    NoofcoinIndustry: "N° de co. dans l'Industrie",
    IndustryRating: "Évaluation de l'industrie",
    Profitability: "Rentabilité",
    Growth: "Croissance",
    FinancialStructurt: "Structure financière",
    Solvency: "Solvabilité",
    SearchCountry: "Rechercher un pays",
  },
  RatingAnalysis: {
    IndustyAnalysis: "Analyse sectorielle",
    GeographicAnalysis: "Analyse géographique",
    CompanyTypeAnalysis: "Analyse du type d'entreprise",
    BiusinessScaleAnalysis: "Analyse de l'échelle d'activité",
    HistoryAnalysis: "Analyse historique",
    NormalDistribution: "Distribution normale",
    SubjectCompany: "Entreprise concernée",
    Probabilityofthesubjectratinginitsindustry:
      "Probabilité d'obtention d'une note dans son secteur",
    Maximum: "Maximum 10 %",
    Mean: "Moyenne",
    Average: "Moyenne",
    Minimum: "Minimum 10 %",
    RatingDistribution: "Distribution des notes",
    Revenue: "Chiffre d'affaires",
    Earning: "Bénéfices",
    TotalAssets: "Actifs totaux",
    Subjectratinginitsindustrybyfinancialindicators:
      "Note du sujet dans son secteur selon les indicateurs financiers",
    Best: "Meilleur",
    Worst: "Pire",
    Rankingofsubject: "Classement du sujet dans son secteur",
    Industy: "Secteur",
    Percentilerank:
      "Classement en percentile : % d'entreprises ayant obtenu une note égale ou inférieure à celle du sujet",
    Historicaldevelopmentofsubject:
      "Évolution historique de la note du sujet dans son secteur",
    IndustryAverage: "Moyenne du secteur",
    SubjectRatingChanges: "Évolution des notes du sujet",
    CreditScore: "Pointage de crédit",
    NOofCompanies: "Nombre d'entreprises",
    ofCompanies: "% d'entreprises",
    CreditRating: "Cote de crédit",
    CompanySize: "Taille de l'entreprise",
    YearsinBusiness: "Nombre d'années d'activité",
    SubjectsIndustryConcentrationAnalysis:
      "Analyse de la concentration industrielle du sujet",
    GeographicdistributionofSubjectsratingintsindustry:
      "Répartition géographique de la note du sujet dans son secteur d'activité",
    GeographicdistributioninSubjectindustry:
      "Répartition géographique dans le secteur d'activité du sujet",
    RatingDistributioninSubjectsLocation:
      "Répartition des notes dans la région du sujet",
    Ratinganalysisofcompanies:
      "Analyse de notation d'entreprises du même secteur avec différentes années d'activité",
    Subjectsratinghistory:
      "Historique de notation du sujet par rapport à ses pairs ayant le même historique",
    Ratingrankingofcompanieswithsamehistory:
      "Classement des entreprises ayant le même historique",
    Ratingstatistics:
      "Statistiques de notation des entreprises ayant les mêmes années d'activité",
    Subjectratingcomparing:
      "Notation du sujet par rapport à ses sociétés homologues avec le",
    Subjectratinginitsgroup: "Évaluation du sujet au sein de son groupe",
    Analysisbasedonnature:
      "Analyse basée sur la nature des entreprises du secteur d'activité du sujet",
    Subjectratingpositioninitscompanytype:
      "Position de notation du sujet dans son type d'entreprise",
    Ratingstatisticsofcompanies:
      "Statistiques de notation des entreprises du même secteur",
    Ratinganalysisofcompanies:
      "Analyse de notation d'entreprises de différentes tailles dans un même secteur",
    Probabilityofsubjectrating:
      "Probabilité d'évaluation du sujet dans son secteur d'activité et dans sa taille",
    Subjectratingcomparingwithindustry:
      "Évaluation du sujet par rapport à ses pairs de son secteur",
    RatingRankingofthecompanies:
      "Classement Classement des entreprises de même taille dans un même secteur",
    Ratingstatisticsofcompanies:
      "Statistiques de notation d'entreprises de même taille et de même secteur",
    Rank: "Rang",
    Rating: "Notation ",
    CompanyType: "Type d'entreprise",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Position sur le marché",
    Revenus: "Chiffre d'affaires",
    NetEarnings: "Bénéfice net",
    NetAssets: "Actif net",
    TotalAssets: "Actif total",
    Employees: "Employés",
    Mean: "Moyenne",
    Average: "Moyenne",
    Maximum: "Maximum (10 %)",
    Worst: "Pire (10 %)",
    Subjectcompany: "Entreprise concernée",
    PerformanceComparison: "Comparaison des performances",
    ProfitabilityRatios: "Ratios de rentabilité",
    Grossmargin: "Marge brute",
    Returnonassets: "Rendement des actifs",
    Returnonequity: "Rendement des capitaux propres",
    OperatingRatios: "Ratios d'exploitation",
    Stockturnover: "Rotation des stocks",
    Assetsturnover: "Rotation des actifs",
    Currentassetturnoverrate: "Taux de roulement actuel des actifs",
    Collectionperiod: "Période de collecte",
    GrowthRatios: "Ratios de croissance",
    Totalassetsgrowthrate: "Taux de croissance du total des actifs",
    Salesgrowthrate: "Taux de croissance des ventes",
    Netprofitgrowthrate: "Taux de croissance du bénéfice net",
    StructuralRatios: "Ratios de structure",
    Debtratio: "Ratio d'endettement",
    Quickratio: "ratio de liquidité générale",
    Currentratio: "Ratio de liquidité",
  },
  AccountCenterMenu: {
    SearchinSettings: "Rechercher dans les Paramètres", //在“设置”中搜索
    Account: "Compte", //账户
    MyAccount: "Mon compte", //我的账户
    ContactInfo: "Coordonnées", //联系信息
    AccountSecurity: "Sécurité du compte", //账户安全
    OrganizationalManagement: "Gestion organisationnelle", //组织管理
    UserGroup: "Groupe d'utilisateurs", //用户组
    User: "Utilisateur", //用户
    Role: "Rôle", //角色
    MyDatabase: "Mon utilisation", //我的数据库
    MyUsage: "Mon utilisation", //我的使用情况
    CompaniesViewed: "Entreprises consultées", //查看过的公司
    ReportsDownloaded: "Rapports téléchargés", //下载的报告
    ReportUpdatesOrdered: "Mises à jour de rapports commandées", //订购的报告更新
    BillingandPayment: "Facturation et paiement", //账单和付款
    BillRecords: "Enregistrements de factures", //账单记录
    PaymentRecords: "Enregistrements de paiement", //付款记录
    CreditDeductions: "Déductions de crédit", //信用扣款
    InvoicesDownloaded: "Factures téléchargées", //下载的发票
    UserSettings: "Paramètres utilisateur", //用户设置
    Messages: "Messages", //消息
    Notifications: "Notifications", //通知
    HelpCenter: "Centre d'aide", //帮助中心
    FAQ: "FAQ", //常见问题
    Privacy: "Conditions", //隐私
    Terms: "Conditions", //条款
    ReportIssues: "Guide de l'utilisateur", //报告问题
    UserGuide: "Guide de l'utilisateur", //用户指南
    AboutCSI: "À propos de CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Heure de connexion", //登录时间
    SignOut: "Déconnexion", //退出
    DeleteAccount: "Supprimer le compte", //删除账户
    AccountID: "Identifiant du compte", //账户ID
    Enteranewaddress: "Saisir une nouvelle adresse e-mail", //输入新的电邮
    EnterVerificationCode: "Saisir le code de vérification", //输入验证码
    SendverificationCode: "Envoyer le code de vérification", //发送验证码
    Password: "Mot de passe", //密码
    Originalpassword: "Mot de passe d'origine", //原始密码
    Newpassword: "Nouveau mot de passe", //新密码
    Confirmnewpassword: "Confirmer le nouveau mot de passe", //确认新密码
    AccountOwnership: "Propriétaire du compte", //账户所有权
    IndividualAccount: "Compte individuel", //个人账户
    GroupAccount: "Compte de groupe", //集团账户
    Organizationname: "Nom de l'organisation", //机构名称
    CountryRegion: "Pays/Région", //国家/地区
    Address: "Adresse", //地址
    City: "Ville", //城市
    ZipCode: "Code postal", //邮政编码
    FirstName: "Prénom", //名字
    LastName: "Nom", //姓氏
    PhoneNumber: "Numéro de téléphone", //电话号码
    Email: "E-mail", //更改
    Change: "Modifier", //更改
    Save: "Enregistrer", //保存
    Cancel: "Annuler", //取消
    LastLogin: "Dernière connexion", //Last Login
    RecentLogin: "Connexion récente", //登录尝试次数
    AverageLoginTime: "Durée moyenne de connexion", //平均登录时间
    TotalLoginAttempts: "Nombre total de tentatives de connexion", //登录尝试次数
    Registrationtime: "Heure d'inscription",
    Role: "Rôle",
    Administrator: "Administrateur",
    Enterpriseusers: "Utilisateurs d'entreprise",
    EditImage: "Modifier l'image",
    DeleteImage: "Supprimer l'image",
  },
  ContactInfo: {
    ContactInfo: "Coordonnées",
    FirstName: "Prénom",
    LastName: "Nom",
    PhoneNumber: "Numéro de téléphone",
    Email: "E-mail",
    CountryRegion: "Pays/Région",
    AddressLine: "Adresse",
    City: "Ville",
    ZipCode: "Code postal",
    Alternativecontactperson: "Autre contact",
    Setascontactperson: "Définir comme contact",
    Edit: "Modifier",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Configurer mes questions de sécurité",
    Pleasechooseaquestion: "Veuillez choisir une question",
    Pleaseentertheanswertothequestion:
      "Veuillez saisir la réponse à la question",
    SessionTimeoutAutomaticLogoutSettings:
      "Délai d'expiration de session : Paramètres de déconnexion automatique",
    Thesystemwillautomatically:
      "Le système vous déconnectera automatiquement après une période d'inactivité. Le délai d'expiration par défaut est de 5 minutes, mais vous pouvez l'ajuster selon vos besoins.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Nombre total d'entreprises recherchées",
    TotalNumberofCompaniesCollected: "Nombre total d'entreprises collectées",
    TotalNumberofUpdateReportsOrdered:
      "Nombre total de rapports de mise à jour commandés",
    Date: "Date",
    UserName: "Nom d'utilisateur",
    CompanyName: "Nom de l'entreprise",
    Status: "Statut",
    UsageType: "Type d'utilisation",
    Entercompanyname: "Saisir le nom de l'entreprise",
    Download: "Télécharger",
  },
  OrganizationalManagement: {
    GroupName: "Nom du groupe",
    ParentGroupName: "Nom du groupe parent",
    Organization: "Organisation",
    GroupID: "ID du groupe",
    GroupStatus: "Statut du groupe",
    Operation: "Opération",
    NewlyBuilt: "Nouvellement créé",
    UserAccount: "Compte utilisateur",
    Role: "Rôle",
    AccountStatus: "Statut du compte",
    RoleName: "Nom du rôle",
    Position: "Poste",
    RoleStatus: "Statut du rôle",
    Valid: "Valide",
    Invalid: "Invalide",
    PermissionSettings: "Paramètres d'autorisation",
    ShowMore: "Afficher plus",
    Search: "Recherche",
    Cancel: "Annuler",
    Confirm: "Confirmer",
    NewGroup: "NouveauGroupe",
    EnterGroupName: "Entrez le nom du groupe",
    NumberofGroups: "Nombre de groupes",
    Groups: "Groupes",
    Roles: "Rôles",
    NewRoles: "Nouveaux rôles",
    EnterNewRole: "Entrez un nouveau rôle",
    Users: "Utilisateurs",
    EnterUserName: "Entrez le nom d'utilisateur",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Nombre total de commandes",
    TotalPaymentAmount: "Montant total du paiement",
    TotalUsedCredits: "Total des crédits utilisés",
    Date: "Date",
    UserAccount: "Compte utilisateur",
    CompanyName: "Nom de l'entreprise",
    OrderNo: "N° de commande",
    OrderType: "Type de commande",
    OrderStatus: "Statut de la commande",
    Download: "Télécharger",
    PaymentAmount: "Montant du paiement",
    Contactus: "Nous contacter",
    DownloadInvoice: "Télécharger la facture",
    CreditUsage: "Utilisation du crédit",
    ReportOrderStatus: "Statut de la commande",
    CompanyID: "Identifiant de l'entreprise",
    CountryRegion: "Pays/Région",
    AddressLine: "Adresse",
    City: "Ville",
    ZipCode: "Code postal",
    FirstName: "Prénom",
    LastName: "Nom",
    PhoneNumber: "Numéro de téléphone",
    Email: "E-mail",
    BankAccountHolderName: "Nom du titulaire du compte bancaire",
    BeneficiaryBankName: "Nom de la banque du bénéficiaire",
    SWIFTCODE: "CODE SWIFT",
    AccountNumber: "Numéro de compte",
    BeneficiaryBankAddress: "Adresse de la banque du bénéficiaire",
    ABA: "Numéro d'acheminement (ABA)",
    IBANnumber: "Numéro IBAN",
    StartingMonth: "Mois de départ",
    EndMonth: "Mois de fin",
    InvoiceInfo: "Informations sur la facture",
  },
  UserSettings: {
    LanguageandLocation: "Langue et localisation",
    Language: "Langue",
    Selectyourpreferedlanguage: "Sélectionnez votre langue préférée",
    Location: "Localisation",
    Selectyourlocation: "Sélectionnez votre localisation",
    NotificationSetting: "Paramètres de notification",
    EmailNotification: "Notification par e-mail",
    ServiceUpdates: "Mises à jour du service",
    CompanyNews: "Actualités de l'entreprise",
  },
  AddCredit: {
    Customizeyourplan: "Personnalisez votre forfait selon vos besoins",
    Silver: "Argent",
    Gold: "Or",
    Enterpris: "Entreprise",
    Credit: "Crédit",
    Remaining: "{0} point restant",
    Usermonth: "utilisateur/mois",
    Useryear: "utilisateur/année",
    PaidMonthlyRenews:
      "Payé mensuellement, pas besoin de renouvellement automatique",
    PaidAnnuallyRenews:
      "Payé annuellement, pas besoin de renouvellement automatique",
    ForFullSupport: "pour un accompagnement complet à vos besoins",
    Each: "chacun",
    CreditsCharged:
      "Les crédits débités sur votre compte n'expireront jamais tant que votre compte reste actif.",
    PaidMonthly: "payé mensuellement",
    PaidAnnually: "payé annuellement",
    BuyNow: "acheter maintenant",
    ContactNow: "contacter maintenant",
    SearchCompanies:
      "Recherchez des entreprises et obtenez un accès instantané aux données de l'entreprise, notamment",
    EverythinginSilverPackage: "Tout dans le forfait Argent, plus",
    CreditsCanbeUsed:
      "Les crédits peuvent être utilisés pour davantage de services de données, notamment les suivants",
    UnlimitedAdvancedSearch: "Recherche avancée illimitée",
    ViewCompanyProfile: "Voir le profil de l'entreprise",
    CompanyOwnershipStructure: "Structure de propriété de l'entreprise",
    CompanyFamilyTree: "Arbre généalogique de l'entreprise",
    Companymanagement: "Gestion d'entreprise",
    CompanyContactsinfo: "Coordonnées de l'entreprise",
    BusinessActivities: "Activités commerciales",
    IndustryBasics: "Les bases de l'industrie",
    ImportExportRecords: "Enregistrements d'importation et d'exportation",
    CompanyPublications: "Publications de l'entreprise",
    CompanyNews: "Actualités de l'entreprise",
    DownloadOnlineReport: "Télécharger le rapport en ligne",
    ManagementDetails: "Détails de gestion",
    ShareholderPenetration: "Pénétration actionnariale (UBO)",
    Financialinfo: "Informations financières",
    FinancialAnalysis: "Analyse financière",
    CreditAssessment: "Évaluation du crédit",
    IndustryAnalysis: "Analyse de l'industrie",
    MarketAnalysis: "Analyse de marché",
    SupplyChaininfo: "Informations sur la chaîne d'approvisionnement",
    CheckSanctions: "Vérifier les sanctions",
    CompanyComparison: "Comparaison d'entreprises",
    DataExport: "Exportation de données",
    MonitoringService: "Service de surveillance",
    DiscountForFreshUpdateReports:
      "Remise pour les nouveaux rapports de mise à jour",
    SearchCompany: "Rechercher une entreprise",
    SearchLeads: "Rechercher des prospects",
    SearchTrade: "Rechercher un commerce",
    SearchPeople: "Rechercher des personnes",
    SearchCountry: "Rechercher un pays",
    SearchNews: "Rechercher des actualités",
    SearchSanction: "Recherche de sanctions",
    DataServices: "Services de données",
    APIPlans: "Forfaits API",
    VolumeDiscounts: "Remises sur volume",
    GroupAccountsWithMultipleUsers:
      "Comptes de groupe avec plusieurs utilisateurs",
    CustomizedPlans: "Forfaits personnalisés",
    FreshInvestigatedCreditReportsWorldwide:
      "Nouveaux rapports de solvabilité étudiés dans le monde entier",
    BusinessMonitoringServices: "Services de veille commerciale",
    BusinessProcessVerificationServices:
      "Services de vérification des processus métiers",
    VendorComplianceReports: "Rapports de conformité des fournisseurs",
    MarketResearch: "Etude de marché",
    More: "Plus…",
    Contactus: "Contactez-nous",
    PaymentMethod: "Mode de paiement",
    CreditCardNumber: "Numéro de carte de crédit",
    EnterCardNumber: "Entrez le numéro de carte",
    ExpirationDate: "Date d'expiration",
    Fullnameoncard: "Nom complet sur la carte",
    EnterFullname: "Entrez le nom complet",
    EnterProvinceState: "Entrez la province/l'État",
    CVCCode: "Code CVC",
    EnterCVCCode: "Entrez le code CVC",
    TotalPurchase: "Achat total",
    Agree1: "En cliquant sur « Envoyer », vous acceptez le ",
    Agree2: "Contrat de services CSI et la confidentialité.",
    Submit: "Soumettre",
    Month: "Mois",
    Year: "Année",
    Country: "Pays",
    ProvinceState: "Province/État",
    Cancel: "Annuler",
    IncorrectCreditCardNumberformat:
      "Format de numéro de carte de crédit incorrect",
    IncorrectExpMonthformat: "Format Exp.Mois incorrect",
    IncorrectExpYearformat: "Format d'année d'exp. incorrect",
    IncorrectFullNameformat: "Format de nom complet incorrect",
    IncorrectCountryformat: "Format de pays incorrect",
    IncorrectProvinceStateformat: "Format de province/état incorrect",
    IncorrectCVCCodeformat: "Format de code CVC incorrect",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "Quel type d'erreurs signalez-vous ?",
    Tellusmoreaboutyourproblems: "Décrivez-nous vos problèmes.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "Souhaitez-vous fournir une capture d'écran ou un fichier concernant votre problème ?",
    Fillinyourcontactinformation: "Indiquez vos coordonnées",
    FirstName: "Prénom",
    LastName: "Nom",
    PhoneNumber: "Numéro de téléphone",
    Email: "E-mail",
    Edit: "Modifier",
  },
  //Risk Scan
  RiskScan: {
    RiskScan: "Risk Scan",
    RiskScanInfo:
      " est votre plateforme tout-en-un pour une analyse complète des risques d'entreprise. Nous fournissons une analyse détaillée de chaque catégorie de risques majeure afin de sécuriser vos décisions commerciales.",
    LegalRisk: "Risque juridique",
    LegalRiskInfo: "Vérifier la légitimité de l’entreprise.",
    OrganizationalRisk: "Risque organisationnel",
    OrganizationalRiskInfo:
      "stabilité de la direction, complexité de la structure de l’entreprise et transparence de la propriété.",
    OperationalRisk: "Risque opérationnel",
    OperationalRiskInfo:
      "vulnérabilités de la chaîne d'approvisionnement, situation opérationnelle et exposition géopolitique.",
    FinancialRisk: "Risques liés à la performance financière",
    FinancialPerformanceRiskInfo:
      "tendances de rentabilité, problèmes de liquidités et santé du bilan.",
    CreditRisk: "Risque de crédit",
    CreditRiskInfo:
      "solvabilité, historique de paiement et probabilité de défaut de paiement.",
    ComplianceRisk: "Risque de non-conformité",
    ComplianceRiskInfo:
      "respect des sanctions, des réglementations en matière de lutte contre le blanchiment d’argent et des lois spécifiques au secteur.",
    SustainabilityRisk: "Risques liés au développement durable",
    SustainabilityRiskInfo:
      "facteurs ESG (environnementaux, sociaux et de gouvernance) et impacts sur la réputation.",
    IndustryRisk: "Risque sectoriel",
    IndustryRiskInfo:
      "Évalue la stabilité et les perspectives de l'ensemble du secteur d'activité d'une entreprise.",
    LetBegin: "Commençons",
    AddcompaniesfromSearchResult:
      "Ajouter des entreprises à partir des résultats de recherche",
    AddcompaniesfromMyDatabase:
      "Ajouter des entreprises depuis Ma base de données",
    Addcompaniesbyuploadmyownlist:
      "Ajouter des entreprises en important ma propre liste",
    Cancel: "Annuler",
    Confirm: "Confirmer",
    UploadFiles: "Téléverser des fichiers",
    PleaseuploadyourfileinCVSformat:
      "Veuillez téléverser votre fichier au format xlsx.",
    Downloadxlsxtemplate: "Télécharger le modèle xlsx",
    Xcompanieswereuploadedsucessfuly: "Les entreprises {0} ont été téléchargées avec succès.",
    Xcompanieswereidentifiedsucessfuly: "Les entreprises {0} ont été identifiées avec succès.",
    Xcompanieswerenotmatched: "Les entreprises {0} n'ont pas pu être appariées.",

    Uploadingfilefailed:
      "Le chargement du fichier a échoué. Veuillez utiliser le modèle et réessayer.",
    ALL: "Tous",
    SearchLeads: "Recherche de prospects",
    LastUpdate: "Dernière mise à jour",
    CompanyID: "ID de l'entreprise",
    CompanyType: "Type d'entreprise",
    RegistrationDate: "Date d'inscription",
    RegistrationStatus: "État d'inscription",
    Listed: "cotée en bourse",
    LegalStatus: "Statut juridique",
    NoofShareholders: "Nombre d'actionnaires",
    ShareholdingLayers: "Niveaux d'actionnariat",
    NoofCorporateShareholders: "Nombre d'actionnaires personnes morales",
    NoofNatualPersonShareholders: "Nombre d'actionnaires personnes physiques",
    RelatedCompanies: "Entreprises apparentées",
    OrganizationalStatus: "Statut organisationnel",
    OperatingAddress: "Adresse d'exploitation",
    IndustryCode: "Code industriel",
    BusinessActivities: "Activités commerciales",
    NoofEmployees: "Nombre d'employés",
    Management: "Gestion",
    CurrentOperations: "Opérations en cours",
    Revenue: "chiffre d'affaires",
    Assests: "Actifs",
    ProfitLoss: "Profit/Perte",
    Liquidity: "Liquidité",
    Growth: "croissance",
    Performance: "performance opérationnelle",
    CreditRating: "notation de crédit",
    CreditScore: "Score de crédit",
    PausibilityofDefault: "Pausibilité du défaut (PD)",
    SolvencyIndex: "Indice de solvabilité",
    DebtCollection: "recouvrement de créances",
    CreditOpinion: "Avis de crédit",
    CompanySanction: "des sanctions contre les entreprises",
    ProductSanction: "Sanction du produit",
    ExportControl: "Contrôle des exportations",
    AntiCorruptionAntiBribery: "Lutte contre la corruption",
    Litigations: "Litiges",
    NegativeNews: "Nouvelles négatives",
    ESGScore: "Score ESG",
    YearsinBusiness: "Années d'activité",
    Competitiveness: "Compétitivité",
    WorkingCapital: "Risque de marché",
    FinancialStructure: "Indice de la chaîne d'approvisionnement",
    Industrystatus: "État de l'industrie",
    IndustryOutlook: "Perspectives du secteur",
    NoofCompanies: "Nombre d'entreprises",
    IndustryRanking: "Classement de l'industrie",
    IndustryConcentration: "PIB industriel %",
    IndustryCompetitiveness: "Industry Competitiveness", //未对应
    IndustryDevelopment: "Industry Development", //未对应
    CompanyName: "Nom de l'entreprise",
    Legal: "Risque juridique",
    Organizational: "Risque organisationnel",
    Operational: "Risque opérationnel",
    Financial: "Risque financier",
    Credit: "Risque de crédit",
    Compliance: "Risques de conformité",
    Sustainability: "Durabilité",
    Industry: "Risque sectoriel",
    Download: "Télécharger",
    StartDate: "Date de début",
    EndDate: "Date de fin",
    Entercompanyname: "Saisir le nom de l'entreprise",
    Tryagain: "Essayer à nouveau",
    //未对应
    Uploadyourlistofcompanies:
      "Upload your list of companies, and Risk Scan will provide you with instant data updates for each entity. With comprehensive risk assessments across seven risk categories, Risk Scan transforms your risk management from reactive to a proactive strategic advantage.",
    Choose: "Choose",
    Upload: "Upload",
    Uploading: "Uploading",
    Uploadwithamaximumfilesizeof1M:
      "(Upload up to 100 pieces of data at a time, with a maximum file size of 1M)",
    Theuploadedonlyxlsx: "The uploaded file can only be in xls/xlsx format",
    RiskScanning: "Risk Scanning",
    Youhaveselectedatotalof: "You have selected a total of",
    Tostartriskscanning: "companies, click “confirm” to start risk scanning",
    Datascanningisinprogress: "Data scanning is in progress ...",
    ClearAll: "Clear All",
    SelectUpdateDate: "Select Last Update",
    UpdateStatus: "Update Status",
    Updated: "Updated",
    Notupdated: "Not updated",
    Updating: "Updating",
    SelectRiskValue: "Select Risk Value",
    ReSelectData: "Re Select Data",
    HistoricalData: "Historical Data",
    DiagnosticReport: "Diagnostic Report",
    Good: "Good",
    General: "General",
    Differ: "Differ",
    NotEvaluated: "Not Evaluated",
    ScanTime: "Scan Time",
  },
  //Data Management
  DataManagement: {
    DataManagement: "gestion des données",
    AllCompanies: "Toutes les entreprises",
    CompaniesViewed: "Entreprises consultées",
    CompaniesCollected: "Les entreprises ont collecté",
    CompaniesUploaded: "Entreprises ayant publié",
    MyPortfolio: "Mon portefeuille",
    Date: "Date",
    CompanyName: "Nom de l'entreprise",
    Country: "Pays",
    CompanyType: "Type d'entreprise",
    CompanyStatus: "Statut de l'entreprise",
    DQI: "DQI",
    Download: "Télécharger",
    Addcompanies: "Ajouter des entreprises",
    Filter: "Filtrer",
    Selectcountry: "Sélectionnez un pays",
    Selectindustry: "Sélectionner le secteur d'activité",
    Selectcompanytype: "Sélectionnez le type d'entreprise",
    Selectcompanysize: "Sélectionnez la taille de l'entreprise",
    Selectcompanystatus: "Sélectionner le statut de l'entreprise",
    Selectlistedcompanies: "Sélectionner les sociétés cotées",
    Selectcompanyyearsinbusiness: "Sélectionnez l'ancienneté de l'entreprise.",
    Industry: "Industrie",
    CompanySize: "Taille de l'entreprise",
    Listed: "cotées",
    CompanyAge: "Âge de l'entreprise",
    SelectYear: "Sélectionner l'année",
    SelectQuarter: "Sélectionner le trimestre",
    SelectMonth: "Sélectionner le mois",
    Reset: "Réinitialiser",
    Search: "Recherche",
    MyDatabase: "Ma base de données",
    Locations: "Implantations",
    YearsinBusiness: "Années d'activité",
    CompanyDQI: "DQI",
    RiskScan: "Analyse des risques",
    CreditAssessment: "Évaluation du crédit",
    Uptodate: "À jour",
    Average: "Moyenne",
    Insufficient: "Insuffisante",
    Good: "Bien",
    Caution: "Prudence",
    Unknown: "Inconnue",
    CompanyTag: "Étiquette de l'entreprise",
    Remove: "Retirer",
    Uploaded: "Téléchargé",
    Identified: "Identifié",
    Notmatched: "Non apparié",
    UploadCompanies: "Ajouter des entreprises",
    Match: "Correspondre",
    Delete: "Supprimer",
    OnlineMatching: "Mise en relation en ligne",
    Identifythecompanywithmanualcheck:
      "Identifier l'entreprise par vérification manuelle",
    Identifyacompanymanually: "Identifier une entreprise manuellement",
    Pleaseprovideanyrelevantinformation:
      "Veuillez fournir toute information pertinente susceptible d'améliorer les résultats de la recherche. Notre analyste de données vous mettra en relation avec l'entreprise la plus adaptée à vos besoins.",
    RegistrationID: "ID d'entreprise",
    StateProvince: "État/Province",
    Address: "Adresse",
    Otherinformation: "Autres informations",
    Submit: "Soumettre",
    Cancel: "Annuler",
    Confirm: "Confirmer",
    EnterRegistrationID: "Saisissez votre identifiant d'inscription",
    EnterAddress: "Saisissez votre adresse",
    EnterInformation: "Saisissez vos informations",
    User: "Utilisatrice",
    Task: "Tâche",
    NoofCompanies: "Nombre d'entreprises",
    Entercompanyname: "Saisissez le nom de l'entreprise",
    SaveYourPortfolio: "Sauvegardez votre portefeuille",
    PortfolioName: "Nom du portefeuille",
    Notes: "Notes",
    Edit: "Modifier",
    EnterPortfolioName: "Saisissez le nom du portefeuille",
    EnterUserName: "Saisir l'utilisateur",
    SelectTaskName: "Sélectionner la tâche",
    EnterNotes: "Saisissez les notes",
    StartingMonth: "Mois de départ",
    EndMonth: "Mois de fin",
  },
  ...frLocale,
};

export default fr;
